// Tiny store factory — gives us getState/setState/subscribe + a React
// hook (useStore) with selector + equality memoization. No external
// dep; ~30 lines does what we need.

import { useSyncExternalStore } from "react"

export function createStore(initial) {
  let state = initial
  const listeners = new Set()

  const getState = () => state
  const setState = (patch) => {
    const next = typeof patch === "function" ? patch(state) : { ...state, ...patch }
    if (next === state) return
    state = next
    listeners.forEach((l) => l())
  }
  const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l) }
  return { getState, setState, subscribe }
}

export function useStore(store, selector = (s) => s) {
  return useSyncExternalStore(store.subscribe, () => selector(store.getState()))
}
